module.exports = __webpack_public_path__ + "img/service-CRM1.c2f34947.svg";